import React, { Component } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

export class MyDocument extends Component {
  render() {
    const styles = StyleSheet.create({
      page: {
        flexDirection: "column",
        padding: 14,
        marginTop: 2,
        fontSize: 10,
      },
      company_info_section: {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        marginBottom: 30,
      },
      employee_info_section: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 15,
      },
      image: {
        width: 60,
        marginRight: 20,
      },
      employee_info_section_left: {
        width: "45%",
      },
      employee_info_section_right: {
        marginLeft: 25,
        width: "40%",
      },
      employee_info: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 8,
      },
      loonStrook: {
        display: "flex",
        flexDirection: "row",
      },
      col_1: {
        width: "20%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_1: {
        width: "20%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_1: {
        width: "20%",
      },
      col_2: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_2: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_2: {
        width: "15%",
      },
      col_3: {
        width: "5%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_3: {
        width: "5%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_3: {
        width: "5%",
      },
      col_4: {
        width: "32%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_4: {
        width: "32%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_4: {
        width: "32%",
      },
      col_5: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_5: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_5: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
      },
      col_6: {
        width: "12%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
        borderRight: 1,
      },
      second_col_6: {
        width: "12%",
        borderBottom: 1,
        borderLeft: 1,
        borderRight: 1,
      },
      third_col_6: {
        width: "12%",
        borderBottom: 1,
        borderLeft: 1,
        borderRight: 1,
        display: "flex",
        justifyContent: "flex-end",
        textAlign: "right",
      },
      col_header: {
        padding: 4,
        borderBottom: 1,
        fontWeight: 700,
      },
      col_footer: {
        padding: 4,
      },
      toelagen_label: {
        marginLeft: 4,
        marginBottom: 4,
      },
      toelagen_value: {
        marginLeft: 4,
        marginBottom: 4,
      },
      inhoudingen_label: {
        marginLeft: 4,
        marginBottom: 4,
      },
      inhoudingen_value: {
        marginLeft: 4,
        marginBottom: 4,
      },
      double: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      },
      inhoudingen_label_double: {
        marginLeft: 4,
        marginRight: 2,
        marginBottom: 4,
      },

      footer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: "auto",
        fontSize: 8,
        marginBottom: 20,
      },

      section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
      },
      text: {
        fontSize: 5,
        fontWeight: 700,
      },
      text2: {
        fontSize: 10,
      },
    });

    const { loonslipData, employee } = this.props.data;
    const { comp: company, image } = this.props;
    const newImage = image.replace("http://", "https://");

    let inhoudingen = [];

    for (const [key, value] of Object.entries(loonslipData)) {
      if (key.startsWith("inhouding") && key !== "inhoudingenSom") {
        if (value.label.length > 0) {
          inhoudingen.push({ ...value });
        }
      }
    }

    const inhoudingRowsLabel = inhoudingen.map((x) => {
      return (
        <Text style={styles.inhoudingen_label} key={x.label + x.bedrag}>
          {x.label}
        </Text>
      );
    });

    const inhoudingRowsValue = inhoudingen.map((x) => {
      return (
        <Text style={styles.inhoudingen_value} key={x.label + x.bedrag}>
          {x.bedrag}
        </Text>
      );
    });

    let toelagen = [];

    for (const [key, value] of Object.entries(loonslipData)) {
      if (key.startsWith("toelage") && key !== "toelagenSom") {
        if (value.label.length > 0) {
          toelagen.push({ ...value });
        }
      }
    }

    const toelagenRowsLabel = toelagen.map((x) => {
      return (
        <Text style={styles.toelagen_label} key={x.label + x.bedrag}>
          {x.label}
        </Text>
      );
    });

    const toelagenRowsValue = toelagen.map((x) => {
      return (
        <Text style={styles.toelagen_value} key={x.label + x.bedrag}>
          {x.bedrag.slice(0, x.bedrag.indexOf("("))}
        </Text>
      );
    });

    const soortLoonstrook = "Maand";
    return (
      <Document>
        <Page size="A5" orientation="landscape" style={styles.page}>
          {/* company info */}
          <View style={styles.company_info_section}>
            <Image style={styles.image} src={newImage} />
            <View>
              <Text style={styles.comp_info}>{company.companyNaam}</Text>
              <Text style={styles.comp_info}>
                {company.adres}, {company.land_stad}
              </Text>
              <Text style={styles.comp_info}>{company.telefoonnummer}</Text>
              <Text style={styles.comp_info}>{company.mobiel}</Text>
            </View>
          </View>
          {/* company info */}

          {/* employee info */}
          <View style={styles.employee_info_section}>
            <View style={styles.employee_info_section_left}>
              <View style={styles.employee_info}>
                <Text>EMPLOYEE NAAM:</Text>
                <Text>{employee.naam}</Text>
              </View>
              <View style={styles.employee_info}>
                <Text>EMPLOYEE#:</Text>
                <Text>{employee.personeelsNummer}</Text>
              </View>
              <View style={styles.employee_info}>
                <Text>ID NUMBER:</Text>
                <Text>{employee.idNummer}</Text>
              </View>
            </View>
            <View style={styles.employee_info_section_right}>
              <View style={styles.employee_info}>
                <Text>SOORT LOONSTROOK:</Text>
                <Text>{soortLoonstrook}</Text>
              </View>
              <View style={styles.employee_info}>
                <Text>START DATUM:</Text>
                <Text>{company.startDatumSalarisRonde}</Text>
              </View>
              <View style={styles.employee_info}>
                <Text>EIND DATUM: </Text>
                <Text>{company.eindDatumSalarisRonde}</Text>
              </View>
            </View>
          </View>
          {/* employee info */}

          {/* loonstrook */}
          <View style={styles.loonStrook}>
            <View style={styles.col_1}>
              <Text style={styles.col_header}>ONTVANGSTEN</Text>
              <Text style={styles.toelagen_label}>BRUTO LOON</Text>
              {toelagenRowsLabel}
            </View>
            <View style={styles.col_2}>
              <Text style={styles.col_header}>BEDRAG SRD</Text>
              <Text style={styles.toelagen_value}>
                {loonslipData.brutoSalaris}
              </Text>
              {toelagenRowsValue}
            </View>
            <View style={styles.col_3}>
              <Text style={styles.col_header}> </Text>
            </View>
            <View style={styles.col_4}>
              <Text style={styles.col_header}>INHOUDINGEN</Text>
              <View style={styles.double}>
                <Text style={styles.inhoudingen_label_double}>
                  LOONBELASTING
                </Text>
                <Text style={styles.inhoudingen_label_double}>
                  {loonslipData.belastingInhoudingBrutosalaris}
                </Text>
              </View>
              <View style={styles.double}>
                <Text style={styles.inhoudingen_label_double}>
                  HEFFINSKORTING
                </Text>
                <Text style={styles.inhoudingen_label_double}>
                  {loonslipData.heffingskorting}
                </Text>
              </View>
              <Text style={styles.inhoudingen_label}>
                AF TE DRAGEN LOONBELASTING
              </Text>
              <Text style={styles.inhoudingen_label}>LOON A.O.V.</Text>
              {inhoudingRowsLabel}
            </View>
            <View style={styles.col_5}>
              <Text style={styles.col_header}>BEDRAG SRD</Text>
              <Text style={styles.inhoudingen_value}> </Text>
              <Text style={styles.inhoudingen_value}> </Text>
              <Text style={styles.inhoudingen_value}>
                {loonslipData.afTeDragenLoonbelasting}
              </Text>
              <Text style={styles.inhoudingen_value}>
                {loonslipData.aovBedrag}
              </Text>
              {inhoudingRowsValue}
            </View>
            <View style={styles.col_6}>
              <Text style={styles.col_header}> </Text>
            </View>
          </View>
          {/* second row */}
          <View style={styles.loonStrook}>
            <View style={styles.second_col_1}>
              <Text style={styles.col_footer}>TOTAAL ONTVANGEN</Text>
            </View>
            <View style={styles.second_col_2}>
              <Text style={styles.col_footer}>
                {loonslipData.totaalTeOntvangen}
              </Text>
            </View>
            <View style={styles.second_col_3}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.second_col_4}>
              <Text style={styles.col_footer}>TOTAAL INHOUDINGEN</Text>
            </View>
            <View style={styles.second_col_5}>
              <Text style={styles.col_footer}>
                {loonslipData.totaalInhoudingen}
              </Text>
            </View>
            <View style={styles.second_col_6}>
              <Text style={styles.col_footer}> </Text>
            </View>
          </View>

          {/* third row */}
          <View style={styles.loonStrook}>
            <View style={styles.third_col_1}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_2}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_3}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_4}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_5}>
              <Text style={styles.col_footer}>NETTO LOON</Text>
            </View>
            <View style={styles.third_col_6}>
              <Text style={styles.col_footer}>{loonslipData.nettoInkomen}</Text>
            </View>
          </View>
          {/* loonstrook */}
          <View style={styles.footer}>
            <View>
              <Text>
                MAAND LOONSTROOK VAN UW ONTVANGSTEN EN INHOUDINGEN | GELIEVE
                DEZE ZORGVULDIG TE BEWAREN
              </Text>
            </View>
            <View>
              <Text>POWERED BY NAMIDI</Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  }
}

export default MyDocument;
